import 'core-js/stable/set-immediate';
import type {BaseLogger, Logger} from 'pino';
import {isAndroid, isBrowser, resolvePath} from '../../utils';
import createMockLogger from './mockLogger';
import createFileTransport, {generateLogName} from './transports/file';
import createConsoleTransport from './transports/console';
import {isKnownLevel, levels} from './utils';

function getOrCreateRootLogger(): Logger {
    if (rootLogger) {
        return rootLogger;
    }

    if (isBrowser() || isAndroid()) {
        throw new Error('Logger is not supported on android');
        // TODO: Support browser logging with isomorphic lib.
        // return rootLogger = pino(
        //     {
        //         level: 'debug',
        //         timestamp: pino.stdTimeFunctions.isoTime,
        //         browser: {
        //             asObject: true
        //         }
        //     },
        // );
    }

    const fileTransport = createFileTransport(defaultLogPath);
    const consoleTransport = createConsoleTransport();

    const pino = require('pino');

    return rootLogger = pino(
        {
            level: 'debug',
            timestamp: pino.stdTimeFunctions.isoTime,
            formatters: {
                level(label: string, number: number) {
                    return {level: isKnownLevel(number) ? levels[number] : label};
                },
            },
        },
        pino.multistream([
            {level: 'info', stream: consoleTransport},
            {level: 'debug', stream: fileTransport},
        ])
    );
}

export function createDefaultLogger(name: string, isDebug: boolean = false) {
    let logger = childLoggers.get(name);
    if (logger) {
        return logger;
    }

    try {
        logger = getOrCreateRootLogger().child({label: name});
    } catch (err) {
        console.warn(`Failed to initialize logger '${name}'.`, err);
        logger = createMockLogger(name, isDebug);
    }
    childLoggers.set(name, logger);
    logger.info('Logger created successfully.');

    return logger;
}

let rootLogger: Logger | undefined;
const childLoggers = new Map<string, BaseLogger>();
const logsFolder = resolvePath('..', 'logs');

export const defaultLogPath = generateLogName(logsFolder);
export type {BaseLogger} from 'pino';
